export const formatStructureForNotification = (token, company, invoice, applyFormatDates = false) => {
	function replaceMonthYear(description, date = new Date()) {  
		const meses = [
			"enero", "febrero", "marzo", "abril", "mayo", "junio",
			"julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
		];
		
		const currentMonth = meses[date.getMonth()];
		const currentYear = date.getFullYear();
	
		const year = date.getFullYear();
		
		const numberpreviousMonth = date.getMonth() - 1;
		const previousMonth = meses[numberpreviousMonth < 0 ? 11 : numberpreviousMonth];
		const previousYear = numberpreviousMonth <= 0 ? year - 1 : year;
		
		const numberAfterMonth = date.getMonth() + 1;
		const afterMonth = meses[numberAfterMonth >= 12 ? 0 : numberAfterMonth];
		const afterYear = numberAfterMonth >= 12 ? year + 1 : year;
		
		let finalText = description.replace("{month/year}", `${currentMonth} ${currentYear}`);
		finalText = finalText.replace("{month-1/year}", `${previousMonth} ${previousYear}`);
		finalText = finalText.replace("{month+1/year}", `${afterMonth} ${afterYear}`);
		return finalText;
	}
	
	const country = invoice?.client?.country == null ? "GT" : invoice?.client?.country;
	
	const notification = {
		token,
		emition_value: "individual",
		country: "GT",
		data: {
			sender: {
				address: company?.address,
				id: company?.id,
				tid: company?.tid,
				name: company?.name,
			},
			receptor: {
				address: invoice?.client? invoice.client.address : invoice.receptor?.address,
				id: invoice?.client? 
					invoice.client?.type === "foreign" ? "temporal" : invoice?.client?.id : 
					invoice.receptor?.type === "foreign" ? "temporal" : invoice?.receptor?.id,
				name: invoice?.client? invoice.client.name : invoice.receptor?.name,
				tid: invoice?.client? invoice.client.tid : invoice.receptor?.tid,
				type_tid: invoice?.client? invoice.client?.type ?? "" : invoice.receptor?.type ?? "",
				country: invoice?.client? 
					invoice.client?.type === "foreign" ? country : "GT":
					invoice.receptor?.type === "foreign" ? country : "GT",
			},
			specs: {
				xchange_rate: (invoice?.xchange_rate || "").toString(),
				instructions: company?.invoice_emition_specifications.instructions || "",
			},
			frases: invoice?.frases,
			type: invoice?.type,
			currency: invoice?.currency,
			establishment_id: invoice?.establishment,
			items: invoice?.items?.map(item => ({
				quantity: item.quantity,
				description: applyFormatDates ?  replaceMonthYear(item.description) : item.description,
				priceUnit: item.priceUnit,
				discount: item.discount || "0",
				taxes: item.taxes.map(tax => ({
					shortName: tax,
				})),
				type: item.type,
				accounting_account: (item.accounting_account || "").toString(),
			})),
			email: invoice?.email,
		},
	};



	return notification;
};